import { Router } from '@angular/router';

/** Query value for `/home?view=oos` — opens the Out-of-Sync left pane on Home. */
export const OUT_OF_SYNC_VIEW_QUERY = 'oos';

/** Absolute URL used by dialogs / status cards that still pass a string link. */
export const OUT_OF_SYNC_HOME_URL = `/home?view=${OUT_OF_SYNC_VIEW_QUERY}`;

/** Navigate to Home and show the Controllers Out-of-Sync dashboard pane. */
export function navigateToOutOfSync(router: Router): void {
    void router.navigate(['/home'], { queryParams: { view: OUT_OF_SYNC_VIEW_QUERY } });
}

export function isOutOfSyncHomeUrl(url: string | null | undefined): boolean {
    if (!url) { return false; }
    // Bare `/home` is the Controllers Dashboard — do not treat it as OOS.
    return url === OUT_OF_SYNC_HOME_URL
        || /[?&]view=oos(?:&|$)/.test(url)
        || url.endsWith('/home?view=oos');
}
